import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/api';
import { IUtente } from '../interfaces/IUtente';
import { UtenteService } from '../services/utente.service';
import { AlertUtil } from '../utils/alert-util';
import * as Enum from '../utils/enums';
import * as Constants from '../utils/constants';
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import { UtenteModalComponent } from '../utente-modal/utente-modal.component';
import { DataTableComponent } from '../data-table/data-table.component';

@Component({
  selector: 'app-referenti',
  templateUrl: './referenti.component.html',
  styleUrls: ['./referenti.component.css']
})
export class ReferentiComponent implements OnInit {

  referenti: IUtente[]  // table data source
  rowSelected: boolean = false    //determines whether one commessa row has been clicked
  referente: IUtente

  isAggiudicatario: boolean

  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html
  payloadUtente: any

  @ViewChild("dtReferenti") dtReferenti: DataTableComponent

  constructor(private utenteService: UtenteService,
    private translate: TranslateService,
    private dialogService: DialogService,
    private alertUtil: AlertUtil) { }

  ngOnInit() {
    this.isAggiudicatario = false
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE)
    if (userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO) {
      this.isAggiudicatario = true
    }
    setTimeout(() => {
      this.getAllReferenti()
    }, 0);
  }

  /**
    * get all referenti
    */
  getAllReferenti() {
    this.setPayloadUtente()
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(this.payloadUtente)
    this.utenteService.getAllReferenti(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.dtReferenti.resetTable()
          this.referenti = response.data
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * 
   */
  onCreateReferente() {
    this.referente = null
    this.openReferenteModal(false)
  }

  /**
   * 
   * @param referenteForUpdate obj
   */
  onUpdateReferente(referenteForUpdate: IUtente) {
    this.referente = referenteForUpdate
    this.openReferenteModal(true)
  }

  /**
   * open new referente modal
  */
  openReferenteModal(isUpdate: boolean) {
    let modalTitle = "LBL_NEW_REFERENTE"
    if (isUpdate) {
      modalTitle = "LBL_UPDATE_REFERENTE"
    }
    //get header translation
    this.translate.get(modalTitle).subscribe(res => {
      let utente = this.referente
      //open esecutori modal
      let referenteModal = this.dialogService.open(UtenteModalComponent, {
        data: {
          utente: utente,
          fromReferente: true
        },
        header: res,
        width: '50%'
      })

      // refresh referenti when modal is closed and newReferente is created
      referenteModal.onClose.subscribe((referenteObj) => {
        if (referenteObj) {
          this.getAllReferenti()
        }
      })
    })
  }

  /**
   * delete object confirmation
   */
  openDeleteDialog(referenteObj: IUtente) {
    this.alertUtil.showConfirmationAlert("LBL_CONFIRM_UTENTE_DELETE", null, null, null, null, () => {
      this.deleteUtente(referenteObj)
    });
  }

  deleteUtente(referenteObj: IUtente) {
    Loading.isLoading = true
    let payload = {
      UserID: referenteObj.UserId
    }
    let reqBuilder = new RequestBuilder(payload)
    this.utenteService.deleteUtente(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          //MESSAGGIO OK 
          this.alertUtil.showAlert("LBL_DELETE_UTENTE_SUCCESS", null, null, null, () => {
            this.getAllReferenti()
          })
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * set payload for API
   */
  setPayloadUtente() {
    this.payloadUtente = {
      ApplicationName: "/"
    }
  }

}
